interface IKEY_FEATURES {
  data: Array<string> | undefined;
}

export const KeyFeatures = ({ data }: IKEY_FEATURES): JSX.Element => {
  if (!data) return <></>;

  return (
    <div className="border border-[#E0E0E0] rounded-md px-7 py-6">
      <div className="text-font-500 text-s-20 font-medium mb-4 sm:text-base">
        Both plans include these benefits!
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-1">
        {data?.map((item, index) => (
          <div key={item + index} className="flex items-start gap-2 mb-4">
            <div className="flex justify-start pt-1">
              <svg
                className="w-4 h-4 sm:w-3 sm:h-3"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM10.5236 5.85692C10.7514 5.62912 10.7514 5.25977 10.5236 5.03197C10.2958 4.80416 9.92644 4.80416 9.69863 5.03197L6.22222 8.50838L4.30137 6.58752C4.07356 6.35972 3.70422 6.35972 3.47641 6.58752C3.2486 6.81533 3.2486 7.18467 3.47641 7.41248L5.80974 9.74581C6.03755 9.97362 6.40689 9.97362 6.6347 9.74581L10.5236 5.85692Z"
                  fill="#16CC65"
                />
              </svg>
            </div>
            <div className="keyFeatures text-blue-550 text-base sm:text-s-12 w-10/12">
              <div dangerouslySetInnerHTML={{ __html: item }}></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
